/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlanDTO { 
    id: number;
    title: string;
    viewType: string;
    isDefault: boolean;
    isVisible: boolean;
    isShared: boolean;
    startDate: string;
    endDate: string;
    planStartDate?: string;
    planEndDate?: string;
    relativeDay: string;
    conversionTypeId: number;
    optimizedForDays: number;
    optimizationLevel: number;
    tableDimension: PlanDTO.TableDimensionEnum;
    targetBudget: number;
    userId?: string;
    rModTime?: string;
    permission: PlanDTO.PermissionEnum;
}
export namespace PlanDTO {
    export type TableDimensionEnum = 'channel' | 'segment' | 'tactic';
    export const TableDimensionEnum = {
        Channel: 'channel' as TableDimensionEnum,
        Segment: 'segment' as TableDimensionEnum,
        Tactic: 'tactic' as TableDimensionEnum
    };
    export type PermissionEnum = 'OWNER' | 'READ' | 'WRITE';
    export const PermissionEnum = {
        Owner: 'OWNER' as PermissionEnum,
        Read: 'READ' as PermissionEnum,
        Write: 'WRITE' as PermissionEnum
    };
}


